// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_format from "../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Icon$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as VersionComparator from "../utils/version/VersionComparator.bs.js";
import * as Languages$Catalyst from "../../../../node_modules/@porterin/catalyst/src/entities/vernacular/Languages.bs.js";
import * as VernacularModuleManager from "./RnrLocales/VernacularModuleManager.bs.js";

function RnrHeader(Props) {
  var getLocaleContentRepo = function (language) {
    var RepoInstance = VernacularModuleManager.getContentModule(language);
    return Curry._1(RepoInstance.getContent, undefined);
  };
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  var content = getLocaleContentRepo(Languages$Catalyst.fromCode(rnrParams.lang));
  var tmp = true;
  if (VersionComparator.getIntegerFromAppVersion(rnrParams.version) < VersionComparator.getRnRHeaderRemovalVersion(undefined)) {
    var match = rnrParams.version_code.trim();
    var tmp$1 = match === "" ? 0 : Caml_format.caml_int_of_string(rnrParams.version_code);
    tmp = tmp$1 >= VersionComparator.getRnRHeaderRemovalVersionCode(undefined);
  }
  if (tmp) {
    return React.createElement("div", {
                className: "c-rnr-header"
              }, React.createElement("button", {
                    className: "c-rnr-header__back-btn",
                    onClick: (function (param) {
                        if (VersionComparator.getIntegerFromAppVersion(rnrParams.version) >= VersionComparator.getAppLinkingMinVersion(undefined)) {
                          PartnerAppInterface.goBack();
                        } else {
                          PartnerAppBackNavigator.goBack();
                        }
                        
                      })
                  }, React.createElement(Icon$Catalyst.BackArrowIcon.make, {
                        className: "c-rnr-header__back-icon",
                        fontSize: "Large"
                      })), React.createElement("div", undefined, content.rnrHome.headerText));
  } else {
    return null;
  }
}

var make = RnrHeader;

export {
  make ,
  
}
/* react Not a pure module */
